import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { connectState, getTrackByFn } from '@y42/angular/util';
import { IconModule } from '@y42/core/icon';
import { map, tap } from 'rxjs';
import { GojsHtmlInfoContextMenuItem } from './gojs-html-info.model';
import { GojsHtmlInfoService } from './gojs-html-info.service';
import { GojsSubContextMenuComponent } from './gojs-sub-context-menu/gojs-sub-context-menu.component';

@UntilDestroy()
@Component({
  selector: 'y42-gojs-html-info',
  standalone: true,
  imports: [CommonModule, MatMenuModule, MatButtonModule, MatDividerModule, IconModule, GojsSubContextMenuComponent],
  templateUrl: './gojs-html-info.component.html',
  styleUrls: ['./gojs-html-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GojsHtmlInfoComponent {
  constructor(private readonly gojsHtmlInfoService: GojsHtmlInfoService) {
    this.toggleContextMenu().pipe(untilDestroyed(this)).subscribe();
  }

  @ViewChild('menuTrigger') menuTrigger?: MatMenuTrigger;

  readonly trackByLabel = getTrackByFn<GojsHtmlInfoContextMenuItem>('label');

  readonly state = connectState(this, {
    tooltipDisplay: this.gojsHtmlInfoService.tooltip$.pipe(map((tooltip) => (tooltip.show ? 'block' : 'none'))),
    tooltipPosition: this.gojsHtmlInfoService.tooltip$.pipe(map((tooltip) => tooltip.position ?? { x: 0, y: 0 })),
    tooltipText: this.gojsHtmlInfoService.tooltip$.pipe(map((tooltip) => tooltip.text)),

    menuPosition: this.gojsHtmlInfoService.contextMenu$.pipe(
      map((menu) => menu.config.settings?.position ?? { x: 0, y: 0 }),
    ),
    menuItems: this.gojsHtmlInfoService.contextMenu$.pipe(map((menu) => menu.menuItems)),
  });

  private toggleContextMenu() {
    return this.gojsHtmlInfoService.contextMenu$.pipe(
      tap(({ config }) =>
        requestAnimationFrame(() => (config.open ? this.menuTrigger?.openMenu() : this.menuTrigger?.closeMenu())),
      ),
    );
  }
}
